export default function reportFilterScript() {
  const filterSelects = document.querySelectorAll('.c-invest-data__reports-filter--select');
  const filterSubmit = document.querySelector('.c-invest-data__reports-filters [type="submit"]');
  
  if (!filterSelects || !filterSubmit) {
    return;
  }

  filterSelects.forEach((select) => {
    select.addEventListener('change', () => {
      filterSubmit.click();
    });
  });
}
